import React from 'react';
import PropTypes from 'prop-types';

import defaultImage from '../../../../images/default-wp-image.jpg';

const FluidImage = ({ image, alt, ...props }) => {
  let altText = '';
  if (alt) altText = alt;
  if (image && image.altText) altText = image.altText;

  if (image && image.imageFile) {
    return <img src={image.sourceUrl} alt={altText} {...props} />;
  }

  if (image) {
    return <img src={image.sourceUrl} alt={altText} {...props} />;
  }

  return (
    <img
      src={defaultImage}
      alt="American Express Business Blueprint logo"
      {...props}
    />
  );
};

FluidImage.propTypes = {
  image: PropTypes.shape({
    altText: PropTypes.string,
    sourceUrl: PropTypes.string,
    imageFile: PropTypes.shape({
      childImageSharp: PropTypes.shape({
        fluid: PropTypes.shape({
          tracedSVG: PropTypes.string,
          aspectRatio: PropTypes.number,
          sizes: PropTypes.string,
          src: PropTypes.string,
          srcSet: PropTypes.string,
        }),
      }),
    }),
  }),
  alt: PropTypes.string,
};

FluidImage.defaultProps = {
  image: null,
  alt: '',
};

export default FluidImage;
